import Vue from 'vue';
import VueRouter from 'vue-router';
import jwtToken from './helpers/jwt-token';
import twoFactorToken from "./helpers/two-factor-token";
import store from './stores/index';
import routes from './routes';
import VueGtm from '@gtm-support/vue2-gtm';

Vue.use(VueRouter);

import {api} from "./config";

const router = new VueRouter({
  mode: 'history',
  linkExactActiveClass: 'active',
  routes
});

Vue.use(VueGtm, {
    id: 'GTM-MR8BSVB',
    enabled: (window.Laravel.env == 'production'),
    vueRouter: router
})

router.beforeEach(async (to, from, next) => {
    // just logged in: localStorage has token, but state does not have auth user
    if (jwtToken.getToken() && !store.getters.isLoggedIn && to.name !== 'login') {
        await axios.get(api.currentUser)
            .then((res) => {
                store.dispatch('setAuthUser', res.data.user);
                store.dispatch('setReferences', res.data.references);
            })
            .catch((err) => {
                if (err.response.status === 401 || err.response.status === 403 || err.response.status === 400) {
                    if ($('.modal-backdrop').length > 0) { // remove backdrop if force jump to login
                        $('.modal-backdrop').removeClass('show');
                    }
                    jwtToken.removeToken(); // unset expired token
                    next({name: 'login'});
                }
            });

        // close any open modals if navigating
        if ($('.modal-backdrop').length > 0) {
            $('.modal-backdrop').remove();
        }
    }

    // logged in and not going to account disabled
    if (jwtToken.getToken() && !store.getters.isLoggedIn && to.name !== 'account_disabled' && to.name !== 'login') {
        // if not active, go to account disabled screen
        if (store.getters.getUser.account_status !== 'Active') {
            next({
                name: 'account_disabled',
                params: {notice: store.getters.getUser.inactive_msg_formatted}
            })
        }
    }

    // if current route is on application pages
    if (to.name === 'investor_application' || to.name === 'business_owner_application') {
      if (store.state.auth.completed_application && store.state.auth.application_status === 'Rejected') {
          next({'name': 'application_rejected'}); // all users with application status rejected go to rejected page
      } else if (store.state.auth.completed_application && store.state.auth.role === 'investor' && store.state.auth.application_status !== 'Approved') {
          next({'name': 'dashboard'}); // all investors go to dashboard
      }  else if (store.state.auth.completed_application && store.state.auth.role === 'businessowner' && store.state.auth.application_status !== 'Approved') {
          next({'name': 'under_review'}); // all completed application bo go to under review
      }
    }

    // if going to dashboard without completing application
    if (to.name === 'dashboard' || to.name === 'balance' || to.name === 'notes' || to.name === 'investor_notes_detailed') {
        if (!store.state.auth.completed_application) {
            //check current user whether if completed the application, if not push them back application forms
            if (store.state.auth.role === 'investor' && store.state.auth.type === 'Individual') {
                next({name: 'investor_application'})
            } else if(store.state.auth.role ===  'investor' && store.state.auth.type === 'Institution') {
                next({name: 'business_owner_application'})
            } else if(store.state.auth.role === 'businessowner') {
                next({name: 'business_owner_application'})
            }
        }
    }

    // route checks if approved application user(investor/bo) only can access
    if (to.meta.requiresApprovedApplication) {
        if (store.getters.isLoggedIn || jwtToken.getToken()) {
            if (!store.state.auth.application_id || ((store.state.auth.role === 'investor' && store.state.auth.type === 'Individual') && !store.state.auth.inv_no)) {
                // user has not applied and is investor/bo role
                if (store.state.auth.role === 'investor' && store.state.auth.type === 'Institution') {
                    next({name: 'business_owner_application'});
                } else if (store.state.auth.role === 'investor' && store.state.auth.type === 'Individual') {
                    next({name: 'investor_application'});
                } else if (store.state.auth.role === 'businessowner') {
                    next({name: 'business_owner_application'});
                } else {
                    // none of the mentioned role, proceed next
                    next();
                }
            } else {
                if (store.getters.isApplicationApproved) { // if approved
                    // check if investor and must first topup
                    if (store.state.auth.role === 'investor' && to.name !== 'balance' && to.name !== 'referral'
                        && !store.getters.isInvestorDoneFirstUp) {
                        // redirect to balance
                        next({name: 'balance', params: {action: 'topup'}}); // go to top up screen
                    }
                    next();
                }
                else { // user still under review
                    // if user has not made first top up as investor, keep redirecting them back to dashboard
                    // As it has the fpx_verify or under_review modal in the dashboard.
                    // preventing users to go other links
                    if (!store.state.auth.verified_name && store.state.auth.role === 'investor') {
                        if (from.query) { // redirect to dashboard with from query
                            next({name: 'dashboard', query: from.query});
                        }
                    }
                    next({name: 'dashboard',query: from.query});
                }
            }
        } else {
            next({name: 'login'});
        }
    }

    // requires authentication
    if (to.meta.requiresAuth) {
        if (store.getters.isLoggedIn || jwtToken.getToken()) {
            next();
        }
        else {
            next({name: 'login'});
        }
    }

    // guest only
    if (to.meta.requiresGuest) {
        if ((store.getters.isLoggedIn || jwtToken.getToken()) && to.name !== 'simulation')
            next({name: 'dashboard'});
        else
            next();
    }

    //if investors application is rejected, bound back to application_rejected and disable the investors to go other links
    if(to.meta.applicationRejected) {
        if ((store.getters.isLoggedIn || jwtToken.getToken()) && store.state.auth.application_status === 'Rejected') {
                next({name: 'application_rejected'});
        }
            next();
    }

    // logged in and and two factor enabled
    if (to.meta.requiresTwoFactor) {
        // if enabled, has to authenticate
        if (store.getters.getUser.check_if_enabled_two_factor == true && !twoFactorToken.getToken()) {
            next({
                name: 'two_factor_page',
            })
        }
    }

    if (to.meta.onlyInvestors) {
        if (store.getters.getUser.role !== 'investor') {
            next({name: 'dashboard'});
        }
    }

    if (to.meta.onlyBusinessOwners) {
        if (store.getters.getUser.role !== 'businessonwer') {
            next({name: 'dashboard'});
        }
    }

    next();
});

router.onError(error => {
    if (/loading chunk \d* failed./i.test(error.message)) {
        window.location.reload()
    }
})


export default router;
